/* src/app/components/planestratamiento/diente/diente.component.scss */
.numero-diente {
  font-size: 10px;
}
/*# sourceMappingURL=diente.component.css.map */
